import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#0A0A0A] border-t border-[#16161F] py-12 px-4" data-id="element-90">
      <div className="max-w-4xl mx-auto text-center" data-id="element-91">
        <div className="text-[#FF6B00] text-2xl font-black tracking-widest mb-4 uppercase" data-id="element-92">
          🏃 P.E. READY 360™
        </div>
        <p className="text-white text-base font-bold mb-2" data-id="element-93">
          The #1 system for PE teachers worldwide.
        </p>
        <p className="text-[#B0B0C0] text-sm italic mb-8 font-medium" data-id="element-94">
          Because teaching PE shouldn't cost you every evening of the week.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-sm text-[#B0B0C0] mb-8 font-bold" data-id="element-95">
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-96">
            📧 support.peready360@gmail.com
          </span>
          <span className="hidden sm:inline text-[#333]" data-id="element-97">•</span>
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-98">
            📲 @peready360
          </span>
          <span className="hidden sm:inline text-[#333]" data-id="element-99">•</span>
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-100">
            🌐 www.peready360.com
          </span>
        </div>

        <div className="h-px bg-[#16161F] mb-8 w-full max-w-md mx-auto" data-id="element-101" />

        <p className="text-[#5A5A66] text-xs font-bold uppercase tracking-wider" data-id="element-102">
          © P.E. READY 360™ 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}